import { createI18n } from 'vue-i18n';

// 语言包
const messages = {
  'zh-CN': {
    common: {
      save: '保存',
      cancel: '取消',
      delete: '删除',
      confirm: '确认',
      search: '搜索',
      add: '新增',
      edit: '编辑',
      view: '查看',
      export: '导出',
      import: '导入',
      refresh: '刷新',
      reset: '重置',
      back: '返回',
      more: '更多',
      loading: '加载中...',
      success: '操作成功',
      error: '操作失败',
      warning: '警告',
      info: '提示',
      yes: '是',
      no: '否'
    },
    auth: {
      login: '登录',
      register: '注册',
      forgotPassword: '忘记密码',
      forgotPasswordSubtitle: '请输入您的邮箱地址，我们将发送重置密码的链接',
      sendResetLink: '发送重置链接',
      email: '邮箱',
      phone: '手机号',
      password: '密码',
      confirmPassword: '确认密码',
      username: '用户名',
      loginSuccess: '登录成功',
      loginFailed: '登录失败',
      registerSuccess: '注册成功',
      registerFailed: '注册失败，请稍后重试',
      logout: '退出登录',
      rememberMe: '记住我',
      forgotPasswordSuccess: '重置密码链接已发送',
      invalidCredentials: '用户名或密码错误',
      emailFormatError: '邮箱格式错误',
      passwordLengthError: '密码长度至少为8位',
      passwordNotMatch: '两次输入的密码不一致',
      passwordMismatch: '两次输入的密码不一致',
      agreement: '我已阅读并同意',
      terms: '服务条款',
      privacy: '隐私政策',
      and: '和',
      enterpriseLogin: '企业登录',
      domain: '企业域名',
      // 新增登录页文案
      continueWith: '或继续使用',
      signInWithGoogle: '使用 Google 登录',
      signUpWithGoogle: '使用 Google 注册',
      showPassword: '显示密码',
      hidePassword: '隐藏密码',
      noAccountQuestion: '还没有账号？',
      haveAccountQuestion: '已经有账号了？',
      // 注册页新增文案
      registerSubtitle: '创建您的VisuDuo SaaS账号',
      accountPlaceholder: '请输入账号标识',
      usernamePlaceholder: '请输入用户名',
      emailPlaceholder: '请输入邮箱',
      companyNamePlaceholder: '请输入公司名称',
      companyInfoPlaceholder: '请输入公司信息（可选）',
      saasUrlPlaceholder: '请输入SaaS域名',
      passwordPlaceholder: '请输入密码',
      confirmPasswordPlaceholder: '请确认密码',
      haveAccount: '已有账号？',
      accountRequired: '请输入账号标识',
      accountLength: '账号长度在 3 到 50 个字符',
      usernameRequired: '请输入用户名',
      usernameLength: '用户名长度在 3 到 20 个字符',
      emailRequired: '请输入邮箱',
      emailInvalid: '请输入正确的邮箱地址',
      passwordRequired: '请输入密码',
      passwordLength: '密码长度在 6 到 20 个字符',
      confirmPasswordRequired: '请确认密码',
      agreeTermsRequired: '请同意服务条款',
      // 重置密码页新增文案
      resetPassword: '重置密码',
      resetPasswordSubtitle: '请输入新密码以完成重置',
      newPassword: '新密码',
      confirmNewPassword: '确认新密码',
      submitReset: '提交重置',
      tokenRequired: '链接无效或缺少参数',
      tokenInvalid: '重置链接已失效，请重新申请',
      resetPasswordSuccess: '密码已重置，请使用新密码登录',
      resetPasswordFailed: '密码重置失败，请稍后重试'
    },
    dashboard: {
      title: 'AI 巡店业务看板',
      overview: '概览',
      statistics: '统计',
      recentActivity: '最近活动',
      quickActions: '快捷操作',
      deviceCount: '设备数量',
      sceneCount: '场景数量',
      alertCount: '告警数量',
      onlineRate: '在线率',
      // 业务补充
      tenants: '租户数',
      activeTenants: '活跃租户',
      devices: '设备数',
      totalDevices: '设备总数',
      scenes: '场景数',
      createdScenes: '已创建场景',
      inspections: '巡店任务',
      completedInspections: '已完成巡店',
      deviceStatus: '设备状态',
      currentDeviceStatus: '当前设备状态',
      inspectionTrend: '巡店合规趋势',
      inspectionTrendDescription: '近7/30/90天合规/不合规趋势',
      recentActivities: '最近活动',
      viewAll: '查看全部',
      addDevice: '添加设备',
      createScene: '创建场景',
      startInspection: '发起巡店',
      manageUsers: '用户管理',
      today: '今天',
      thisWeek: '本周',
      thisMonth: '本月',
      last7Days: '最近7天',
      last30Days: '最近30天',
      last90Days: '最近90天',
      selectPeriod: '选择周期',
      // AI 巡店关键指标
      aiStorePatrolTitle: 'AI 巡店业务看板',
      aiStorePatrolDesc: '展示门店运营关键指标与AI巡店合规情况',
      footfall: '客流量',
      conversionRate: '转化率',
      avgDwellTime: '平均停留时长',
      queueTime: '平均排队时长',
      avgQueueWait: '平均排队时长',
      shelfCompliance: '陈列合规率',
      stockOutAlerts: '缺货告警',
      zoneHeatmap: '店内区域热力图',
      storeHeatmap: '店内热力图与动线',
      currentDistribution: '当前分布',
      patrolComplianceTrend: '巡店合规趋势',
      conversionFunnel: '转化漏斗',
      queueMetrics: '队列效率趋势',
      queueLength: '排队长度',
      queueWaitTime: '等待时长',
      compliance: '合规',
      minorViolation: '轻微不合规',
      majorViolation: '严重不合规',
      topStoreCompliance: '门店陈列合规 Top N',
      outOfStockTrend: '缺货 SKU 趋势',
      // Filters & Tasks
      brand: '品牌',
      region: '区域',
      store: '门店',
      timeRange: '时间范围',
      apply: '应用',
      reset: '重置',
      patrolTasks: '巡店任务列表',
      patrolTasksSubtitle: '最近的巡店任务与合规进度',
      taskName: '任务名称',
      assignee: '负责人',
      dueDate: '截止日期',
      priority: '优先级',
      status: '状态',
      complianceScore: '合规得分',
      actions: '操作',
      exportCsv: '导出 CSV',
      viewDetails: '查看详情',
      alertsToday: '今日告警',
      alertsOpen: '未关闭告警',
      patrolsToday: '今日巡店次数',
      storeCount: '已创建门店数',
      onlineDevices: '在线设备数',
      tasksOpen: '未关闭任务数'
    },
    reports: {
      title: '报表中心',
      selectStore: '选择门店',
      storeId: '门店ID',
      tabs: {
        conversion: '转化漏斗',
        queue: '队列趋势',
        heatmap: '店内热力图',
        compliance: '合规趋势',
        flow: '客流分析',
        sku: 'SKU画像',
        stock: '库存与缺货',
        health: '设备健康/告警分布',
        tasks: '任务效率'
      },
      metrics: { people: '人', minutes: '分', days: '天' },
      btn: {
        configureFloorplan: '配置平面图',
        copyLink: '复制链接',
        exportImage: '导出图片',
        exportZoneJson: '导出区域JSON',
        backOverview: '返回概览',
        exportReport: '导出报表',
        loadData: '加载数据'
      },
      filter: {
        device: '选择设备',
        to: '至',
        start: '开始时间',
        end: '结束时间',
        preset: '时间预设',
        last2h: '最近2小时',
        last24h: '最近24小时',
        last7d: '最近7天',
        dataKeyPlaceholder: '数据键（如fps、cpu、memory）',
        queueBucket: '聚合分钟',
        slaMinutes: 'SLA分钟',
        zone: '选择区域',
        overlay: '叠加类型'
      },
      overlay: {
        hotspot: '停留hotspot',
        trajectory: '动线轨迹'
      },
      funnel: { stepCount: '步骤数' },
      heatmap: {
        zoneStatsTitle: '区域统计',
        zone: '区域',
        cells: '格子数',
        total: '热度总和',
        avg: '平均热度'
      },
      flow: {
        title: '客流画像分布',
        segmentCount: '分类数',
        segment: {
          placeholder: '分析维度',
          dwell: '停留时长',
          gender: '性别',
          age: '年龄段',
          returning: '新客/回头客'
        }
      },
      sku: { title: '热销SKU画像Top-N' },
      table: {
        title: '数据表',
        dataCount: '数据量',
        time: '时间',
        date: '日期',
        classification: '分类',
        people: '人数',
        sales: '销量',
        persona: '画像',
        key: '键',
        value: '值'
      },
      queue: { waitTimeSec: '等待时长(秒)' },
      trend: {
        footfall: '客流量趋势',
        queue: '队列效率趋势',
        flow: '客流分析趋势',
        sku: 'SKU画像趋势',
        stock: '缺货趋势',
        titleDefault: '设备趋势'
      },
      msg: {
        noDeviceSelected: '请先选择设备',
        linkCopied: '链接已复制',
        copyFailed: '复制失败',
        chartNotReady: '图表尚未准备好',
        exportNoData: '暂无可导出的数据',
        exportFail: '导出失败'
      },
      stock: {
        safetyStockDays: '安全库存天数',
        turnoverDays: '周转天数',
        stockoutRisk: '缺货风险',
        outOfStockSkuCount: '缺货SKU数',
        replenishmentAdvice7d: '7日补货建议',
        currentStock: '当前库存',
        forecastDemand7d: '7日预测需求',
        recommendedOrderQty: '建议订货量',
        urgency: '紧急程度'
      }
    },
    devices: {
      title: '设备管理',
      deviceList: '设备列表',
      deviceName: '设备名称',
      deviceType: '设备类型',
      status: '状态',
      online: '在线',
      offline: '离线',
      unknown: '未知',
      ipAddress: 'IP地址',
      macAddress: 'MAC地址',
      lastActive: '最后活跃',
      location: '位置',
      addDevice: '添加设备',
      editDevice: '编辑设备',
      deleteDevice: '删除设备',
      deviceDetail: '设备详情',
      deviceSettings: '设备设置',
      deviceControl: '设备控制'
    },
    scenes: {
      title: '场景管理',
      sceneList: '场景列表',
      sceneName: '场景名称',
      sceneDescription: '场景描述',
      createTime: '创建时间',
      updateTime: '更新时间',
      addScene: '添加场景',
      editScene: '编辑场景',
      deleteScene: '删除场景',
      sceneDetail: '场景详情',
      sceneActions: '场景动作',
      sceneTriggers: '场景触发器'
    },
    alerts: {
      title: '告警管理',
      alertList: '告警列表',
      alertLevel: '告警级别',
      info: '信息',
      warning: '警告',
      error: '错误',
      critical: '严重',
      alertType: '告警类型',
      alertMessage: '告警消息',
      alertTime: '告警时间',
      resolveTime: '解决时间',
      status: '状态',
      unprocessed: '未处理',
      processing: '处理中',
      resolved: '已解决',
      ignored: '已忽略',
      processAlert: '处理告警',
      resolveAlert: '解决告警',
      ignoreAlert: '忽略告警',
      alertDetail: '告警详情',
      alertHistory: '告警历史'
    },
    users: {
      title: '用户管理',
      userList: '用户列表',
      userName: '用户名',
      email: '邮箱',
      phone: '手机号',
      role: '角色',
      status: '状态',
      active: '活跃',
      inactive: '禁用',
      createTime: '创建时间',
      addUser: '添加用户',
      editUser: '编辑用户',
      deleteUser: '删除用户',
      resetPassword: '重置密码',
      userDetail: '用户详情',
      userPermissions: '用户权限',
      permissionSectionTitle: '角色与权限',
      accessScopeTitle: '可访问范围',
      storeDeviceMappingTitle: '门店设备映射',
      permissions: '权限',
      accessLevel: '层级',
      assignedRegions: '关联区域',
      assignedStores: '关联门店',
      selectPermissions: '选择权限',
      selectRegions: '选择区域',
      selectStores: '选择门店',
      rolePlaceholder: '用户角色',
      statusPlaceholder: '用户状态',
      searchPlaceholder: '搜索用户名、邮箱、手机号',
      roles: { admin: '管理员', operator: '操作员', viewer: '查看者' },
      statusOptions: { active: '启用', inactive: '禁用', pending: '未激活' },
      viewUser: '查看用户',
      actions: '操作',
      enable: '启用',
      disable: '禁用',
      cameraId: '摄像头ID',
      edgeBoxId: '算力盒ID',
      channel: '通道',
      addRow: '新增行',
      saveMapping: '保存映射',
      mappingSaved: '映射已保存',
      saveMappingFailed: '保存映射失败',
      addUserSuccess: '用户添加成功',
      updateUserSuccess: '用户更新成功',
      disableUserFailed: '禁用用户失败',
      enableUserFailed: '启用用户失败',
      confirmDisableTitle: '确认禁用',
      confirmEnableTitle: '确认启用',
      confirmDisableText: '确定要禁用用户"{name}"吗？',
      confirmEnableText: '确定要启用用户"{name}"吗？',
      // 组织结构相关
      description: '管理系统用户和组织结构',
      orgStructure: '组织结构',
      nodeDetails: '节点详情',
      nodeType: '节点类型',
      nodeId: '节点ID',
      hq: '总部',
      region: '区域',
      store: '门店',
      regionCode: '区域代码',
      storeCode: '门店代码',
      storeAddress: '门店地址',
      storeManager: '店长',
      storePhone: '联系电话',
      storeStatus: '状态',
      addRegion: '新增区域',
      addStore: '新增门店'
    },
    profile: {
      title: '个人中心',
      personalInfo: '个人信息',
      accountSettings: '账户设置',
      changePassword: '修改密码',
      notificationSettings: '通知设置',
      name: '姓名',
      avatar: '头像',
      updateInfo: '更新信息',
      currentPassword: '当前密码',
      newPassword: '新密码',
      confirmNewPassword: '确认新密码',
      passwordChangedSuccess: '密码修改成功',
      // 登录设备相关
      loginDevices: '登录设备',
      device: '设备',
      os: '操作系统',
      browser: '浏览器',
      ipAddress: 'IP地址',
      location: '位置',
      lastActive: '最后活跃',
      currentDevice: '当前设备'
    },
    settings: {
      title: '系统设置',
      basicSettings: '基本设置',
      advancedSettings: '高级设置',
      securitySettings: '安全设置',
      notificationSettings: '通知设置',
      languageSettings: '语言设置',
      appearanceSettings: '外观设置',
      systemInfo: '系统信息',
      version: '版本',
      updateSettings: '更新设置',
      saveSettings: '保存设置',
      settingsSaved: '设置已保存',
      // 偏好设置相关
      preferences: '偏好设置',
      theme: '界面主题',
      language: '语言',
      notifications: '通知设置',
      light: '浅色',
      dark: '深色',
      auto: '自动',
      email: '邮件',
      push: '推送',
      sms: '短信'
    },

  },
  'en-US': {
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      confirm: 'Confirm',
      search: 'Search',
      add: 'Add',
      edit: 'Edit',
      view: 'View',
      export: 'Export',
      import: 'Import',
      refresh: 'Refresh',
      reset: 'Reset',
      back: 'Back',
      more: 'More',
      loading: 'Loading...',
      success: 'Success',
      error: 'Error',
      warning: 'Warning',
      info: 'Info',
      yes: 'Yes',
      no: 'No'
    },
    auth: {
      login: 'Login',
      register: 'Register',
      forgotPassword: 'Forgot Password',
      forgotPasswordSubtitle: 'Please enter your email address, we will send a reset link to you',
      sendResetLink: 'Send reset link',
      email: 'Email',
      phone: 'Phone',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      username: 'Username',
      loginSuccess: 'Login Success',
      loginFailed: 'Login Failed',
      registerSuccess: 'Register Success',
      registerFailed: 'Register failed, please try again later',
      logout: 'Logout',
      rememberMe: 'Remember Me',
      forgotPasswordSuccess: 'Password reset link sent',
      invalidCredentials: 'Invalid username or password',
      emailFormatError: 'Invalid email format',
      passwordLengthError: 'Password must be at least 8 characters',
      passwordNotMatch: 'Passwords do not match',
      passwordMismatch: 'Passwords do not match',
      agreement: 'I have read and agree to the',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
      and: 'and',
      enterpriseLogin: 'Enterprise Login',
      domain: 'Enterprise Domain',
      // Added login page texts
      continueWith: 'or continue with',
      signInWithGoogle: 'Sign in with Google',
      signUpWithGoogle: 'Sign up with Google',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      noAccountQuestion: "Don't have an account?",
      haveAccountQuestion: 'Already have an account?',
      // Register page texts
      registerSubtitle: 'Create your VisuDuo SaaS account',
      usernamePlaceholder: 'Enter username',
      emailPlaceholder: 'Enter email',
      companyNamePlaceholder: 'Enter company name',
      companyInfoPlaceholder: 'Enter company information (optional)',
      saasUrlPlaceholder: 'Enter SaaS domain (optional)',
      passwordPlaceholder: 'Enter password',
      confirmPasswordPlaceholder: 'Confirm password',
      haveAccount: 'Already have an account?',
      usernameRequired: 'Please enter username',
      usernameLength: 'Username length must be between 3 and 20 characters',
      emailRequired: 'Please enter email',
      emailInvalid: 'Please enter a valid email address',
      passwordRequired: 'Please enter password',
      passwordLength: 'Password length must be between 6 and 20 characters',
      confirmPasswordRequired: 'Please confirm password',
      agreeTermsRequired: 'Please agree to the terms of service',
      // Reset password page texts
      resetPassword: 'Reset Password',
      resetPasswordSubtitle: 'Please enter a new password to complete reset',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
      submitReset: 'Submit Reset',
      tokenRequired: 'Invalid link or missing parameter',
      tokenInvalid: 'The reset link has expired, please request again',
      resetPasswordSuccess: 'Password has been reset, please login with your new password',
      resetPasswordFailed: 'Failed to reset password, please try again later'
    },
    dashboard: {
      title: 'AI Store Patrol Dashboard',
      overview: 'Overview',
      statistics: 'Statistics',
      recentActivity: 'Recent Activity',
      quickActions: 'Quick Actions',
      deviceCount: 'Device Count',
      sceneCount: 'Scene Count',
      alertCount: 'Alert Count',
      onlineRate: 'Online Rate',
      // Business additions
      tenants: 'Tenants',
      activeTenants: 'Active Tenants',
      devices: 'Devices',
      totalDevices: 'Total Devices',
      scenes: 'Scenes',
      createdScenes: 'Created Scenes',
      inspections: 'Patrol Tasks',
      completedInspections: 'Completed Patrols',
      deviceStatus: 'Device Status',
      currentDeviceStatus: 'Current Device Status',
      inspectionTrend: 'Patrol Compliance Trend',
      inspectionTrendDescription: 'Compliance vs. violations in last 7/30/90 days',
      recentActivities: 'Recent Activities',
      viewAll: 'View All',
      addDevice: 'Add Device',
      createScene: 'Create Scene',
      startInspection: 'Start Patrol',
      manageUsers: 'Manage Users',
      today: 'Today',
      thisWeek: 'This Week',
      thisMonth: 'This Month',
      last7Days: 'Last 7 Days',
      last30Days: 'Last 30 Days',
      last90Days: 'Last 90 Days',
      selectPeriod: 'Select Period',
      // AI Store Patrol KPIs
      aiStorePatrolTitle: 'AI Store Patrol Dashboard',
      aiStorePatrolDesc: 'Key store operations metrics and AI patrol compliance',
      footfall: 'Footfall',
      conversionRate: 'Conversion Rate',
      avgDwellTime: 'Avg. Dwell Time',
      queueTime: 'Avg. Queue Time',
      avgQueueWait: 'Avg. Queue Time',
      shelfCompliance: 'Shelf Compliance',
      stockOutAlerts: 'Stock-out Alerts',
      zoneHeatmap: 'In-store Zone Heatmap',
      storeHeatmap: 'Store Heatmap & Trajectories',
      currentDistribution: 'Current Distribution',
      patrolComplianceTrend: 'Patrol Compliance Trend',
      conversionFunnel: 'Conversion Funnel',
      queueMetrics: 'Queue Efficiency Trend',
      queueLength: 'Queue Length',
      queueWaitTime: 'Wait Time',
      compliance: 'Compliance',
      minorViolation: 'Minor Violation',
      majorViolation: 'Major Violation',
      topStoreCompliance: 'Top Stores Compliance',
      outOfStockTrend: 'Out-of-stock SKU Trend',
      // Filters & Tasks
      brand: 'Brand',
      region: 'Region',
      store: 'Store',
      timeRange: 'Time Range',
      apply: 'Apply',
      reset: 'Reset',
      patrolTasks: 'Patrol Tasks',
      patrolTasksSubtitle: 'Recent patrol tasks and compliance progress',
      taskName: 'Task Name',
      assignee: 'Assignee',
      dueDate: 'Due Date',
      priority: 'Priority',
      status: 'Status',
      complianceScore: 'Compliance Score',
      actions: 'Actions',
      exportCsv: 'Export CSV',
        viewDetails: 'View Details',
        alertsToday: 'Alerts Today',
        alertsOpen: 'Open Alerts',
        patrolsToday: 'Patrols Today',
        storeCount: 'Stores Created',
        onlineDevices: 'Online Devices',
        tasksOpen: 'Open Tasks'
      },
     reports: {
       title: 'Reports Center',
       selectStore: 'Select Store',
       storeId: 'Store ID',
       tabs: {
         conversion: 'Conversion Funnel',
        queue: 'Queue Trend',
        heatmap: 'Store Heatmap',
        compliance: 'Compliance Trend',
        flow: 'Flow Analysis',
        sku: 'SKU Persona',
        stock: 'Inventory & Stock-out',
        health: 'Device Health & Alerts',
        tasks: 'Task Efficiency'
      },
       metrics: { people: 'people', minutes: 'min', days: 'days' },
       btn: {
         configureFloorplan: 'Configure Floorplan',
         copyLink: 'Copy Link',
         exportImage: 'Export Image',
         exportZoneJson: 'Export Zone JSON',
         backOverview: 'Back to Overview',
         exportReport: 'Export Report',
         loadData: 'Load Data'
       },
       filter: {
         device: 'Select Device',
         to: 'to',
         start: 'Start Time',
         end: 'End Time',
         preset: 'Preset',
         last2h: 'Last 2 hours',
         last24h: 'Last 24 hours',
         last7d: 'Last 7 days',
         dataKeyPlaceholder: 'Data key (e.g. fps, cpu, memory)',
         queueBucket: 'Bucket minutes',
         slaMinutes: 'SLA minutes',
         zone: 'Select Zone',
         overlay: 'Overlay Type'
       },
       overlay: {
         hotspot: 'Dwell hotspot',
         trajectory: 'Trajectory'
       },
       funnel: { stepCount: 'Steps' },
       heatmap: {
         zoneStatsTitle: 'Zone Statistics',
         zone: 'Zone',
         cells: 'Cells',
         total: 'Total Heat',
         avg: 'Avg. Heat'
       },
       flow: {
         title: 'Footfall Segment Distribution',
         segmentCount: 'Segments',
         segment: {
           placeholder: 'Segment Dimension',
           dwell: 'Dwell Time',
           gender: 'Gender',
           age: 'Age Group',
           returning: 'New vs Returning'
         }
       },
       sku: { title: 'Top-N Hot SKU Personas' },
       table: {
         title: 'Data Table',
         dataCount: 'Data Count',
         time: 'Time',
         date: 'Date',
         classification: 'Classification',
         people: 'People',
         sales: 'Sales',
         persona: 'Persona',
         key: 'Key',
         value: 'Value'
       },
       queue: { waitTimeSec: 'Wait Time (sec)' },
       trend: {
         footfall: 'Footfall Trend',
         queue: 'Queue Efficiency Trend',
         flow: 'Footfall Analysis Trend',
         sku: 'SKU Personas Trend',
         stock: 'Stock-out Trend',
         titleDefault: 'Device Trend'
       },
       msg: {
         noDeviceSelected: 'Please select a device first',
         linkCopied: 'Link copied',
         copyFailed: 'Copy failed',
         chartNotReady: 'Chart not ready',
         exportNoData: 'No data to export',
         exportFail: 'Export failed'
       },
       stock: {
         safetyStockDays: 'Safety Stock Days',
         turnoverDays: 'Turnover Days',
         stockoutRisk: 'Stock-out Risk',
         outOfStockSkuCount: 'Out-of-stock SKU Count',
         replenishmentAdvice7d: '7-day Replenishment Advice',
         currentStock: 'Current Stock',
         forecastDemand7d: '7-day Forecast Demand',
         recommendedOrderQty: 'Recommended Order Qty',
         urgency: 'Urgency'
       }
     },
     devices: {
      title: 'Device Management',
      deviceList: 'Device List',
      deviceName: 'Device Name',
      deviceType: 'Device Type',
      status: 'Status',
      online: 'Online',
      offline: 'Offline',
      unknown: 'Unknown',
      ipAddress: 'IP Address',
      macAddress: 'MAC Address',
      lastActive: 'Last Active',
      location: 'Location',
      addDevice: 'Add Device',
      editDevice: 'Edit Device',
      deleteDevice: 'Delete Device',
      deviceDetail: 'Device Detail',
      deviceSettings: 'Device Settings',
      deviceControl: 'Device Control'
    },
    scenes: {
      title: 'Scene Management',
      sceneList: 'Scene List',
      sceneName: 'Scene Name',
      sceneDescription: 'Scene Description',
      createTime: 'Create Time',
      updateTime: 'Update Time',
      addScene: 'Add Scene',
      editScene: 'Edit Scene',
      deleteScene: 'Delete Scene',
      sceneDetail: 'Scene Detail',
      sceneActions: 'Scene Actions',
      sceneTriggers: 'Scene Triggers'
    },
    alerts: {
      title: 'Alert Management',
      alertList: 'Alert List',
      alertLevel: 'Alert Level',
      info: 'Info',
      warning: 'Warning',
      error: 'Error',
      critical: 'Critical',
      alertType: 'Alert Type',
      alertMessage: 'Alert Message',
      alertTime: 'Alert Time',
      resolveTime: 'Resolve Time',
      status: 'Status',
      unprocessed: 'Unprocessed',
      processing: 'Processing',
      resolved: 'Resolved',
      ignored: 'Ignored',
      processAlert: 'Process Alert',
      resolveAlert: 'Resolve Alert',
      ignoreAlert: 'Ignore Alert',
      alertDetail: 'Alert Detail',
      alertHistory: 'Alert History'
    },
    profile: {
      title: 'Profile',
      personalInfo: 'Personal Info',
      accountSettings: 'Account Settings',
      changePassword: 'Change Password',
      notificationSettings: 'Notification Settings',
      name: 'Name',
      avatar: 'Avatar',
      updateInfo: 'Update Info',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
      passwordChangedSuccess: 'Password changed successfully',
      loginDevices: 'Login Devices',
      device: 'Device',
      os: 'OS',
      browser: 'Browser',
      ipAddress: 'IP Address',
      location: 'Location',
      lastActive: 'Last Active',
      currentDevice: 'Current Device'
    },
    settings: {
      title: 'System Settings',
      basicSettings: 'Basic Settings',
      advancedSettings: 'Advanced Settings',
      securitySettings: 'Security Settings',
      notificationSettings: 'Notification Settings',
      languageSettings: 'Language Settings',
      appearanceSettings: 'Appearance Settings',
      systemInfo: 'System Info',
      version: 'Version',
      updateSettings: 'Update Settings',
      saveSettings: 'Save Settings',
      settingsSaved: 'Settings saved',
      preferences: 'Preferences',
      theme: 'Theme',
      language: 'Language',
      notifications: 'Notifications',
      light: 'Light',
      dark: 'Dark',
      auto: 'Auto',
      email: 'Email',
      push: 'Push',
      sms: 'SMS'
    }
  }
};

// 创建i18n实例
export const i18n = createI18n({
  legacy: false,
  locale: 'zh-CN',
  fallbackLocale: 'zh-CN',
  messages
});

export default i18n;
